import React, { Component } from 'react';
import PropTypes from 'prop-types';
import whitelabelThemes from '@spp/roc-package-hyperion/app/theme/whitelabel';
import { SelectedThemeProvider } from '@spp/theme-provider';

import localThemes from '../../theme';

export default class EmbedComponent extends Component {
    static defaultProps = {
        children: [],
    };

    static propTypes = {
        children: PropTypes.node,
    };

    render() {
        return (
            <SelectedThemeProvider
                whitelabelThemesMapping={whitelabelThemes}
                localThemesMapping={localThemes}
            >
                {this.props.children}
            </SelectedThemeProvider>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/embed/index.js
 **/